import { DashboardOrderDetails } from "./DashboardOrderDetails"

export class DashboardBuildStepDetails {
  buildStepName: string
  orders: DashboardOrderDetails[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(json: any) {
    this.buildStepName = json.buildStepName

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.orders = json.orders.map((orderJson: any) => new DashboardOrderDetails(orderJson))
  }
}
